module.exports = __webpack_public_path__ + "img/manjian.69de95e9.png";